import { Colors } from '~/themes/colors';

export enum CandidateStatus {
  New = 'new',
  Applied = 'applied',
  AppExpired = 'app_expired',
  Cancelled = 'cancelled',
  Hired = 'hired',
  Interviewed = 'interviewed',
  Rejected = 'rejected',
  Scheduled = 'scheduled',
}

const colors: Record<CandidateStatus, string> = {
  [CandidateStatus.New]: Colors.primary_500,
  [CandidateStatus.Applied]: Colors.primary_500,
  [CandidateStatus.AppExpired]: Colors.warning_400,
  [CandidateStatus.Cancelled]: Colors.neutral_400,
  [CandidateStatus.Hired]: Colors.success_500,
  [CandidateStatus.Interviewed]: Colors.neutral_400,
  [CandidateStatus.Rejected]: Colors.error_450,
  [CandidateStatus.Scheduled]: Colors.secondary_600,
};

const translationsHumanReadable: Record<CandidateStatus, string> = {
  [CandidateStatus.New]: 'New',
  [CandidateStatus.Applied]: 'New',
  [CandidateStatus.AppExpired]: 'App. Expired',
  [CandidateStatus.Cancelled]: 'Cancelled',
  [CandidateStatus.Hired]: 'Hired',
  [CandidateStatus.Interviewed]: 'Interviewed',
  [CandidateStatus.Rejected]: 'Rejected',
  [CandidateStatus.Scheduled]: 'Scheduled',
};

const translationsProcessStep: Record<CandidateStatus, string> = {
  [CandidateStatus.New]: 'New',
  [CandidateStatus.Applied]: 'Recently Applied',
  [CandidateStatus.AppExpired]: 'App. Expired',
  [CandidateStatus.Cancelled]: 'Cancelled',
  [CandidateStatus.Hired]: 'Hired',
  [CandidateStatus.Interviewed]: 'Interviewed',
  [CandidateStatus.Rejected]: 'Rejected',
  [CandidateStatus.Scheduled]: 'Scheduled',
};

export const CandidateStatusMapper = {
  getColor: (it: CandidateStatus) => colors[it],
  toHumanReadable: (it: CandidateStatus) => translationsHumanReadable[it],
  toProcessStep: (it: CandidateStatus) => translationsProcessStep[it],
};
